const HERO_CTA_BG_VARS = {
  White: 'var(--white)',
  Black: 'var(--black)',
  'Ginst yellow': 'var(--ginst-yellow)',
  'Ocean blue': 'var(--ocean-blue)',
  'Deep blue': 'var(--deep-blue)',
  'Stone blue': 'var(--stone-blue)',
  'Vass green': 'var(--vass-green)',
};

function normalizeHeroCtaBackgroundKey(value) {
  if (!value) {
    return null;
  }

  const trimmed = String(value).trim();

  return HERO_CTA_BG_VARS[trimmed] ? trimmed : null;
}

function getHeroCtaTextColor(key) {
  if (key === 'Deep blue' || key === 'Black') {
    return 'var(--white)';
  }

  if (key === 'White') {
    return 'var(--deep-blue)';
  }

  return 'var(--deep-blue)';
}

function getHeroCtaHoverColors(key) {
  if (key === 'White') {
    return {
      '--hero-cta-hover-bg': 'var(--deep-blue)',
      '--hero-cta-hover-color': 'var(--white)',
    };
  }

  return {
    '--hero-cta-hover-bg': 'var(--white)',
    '--hero-cta-hover-color': 'var(--deep-blue)',
  };
}

export function getHeroCtaStyle(value) {
  const key = normalizeHeroCtaBackgroundKey(value);

  if (!key) {
    return undefined;
  }

  const backgroundColor = HERO_CTA_BG_VARS[key];

  return {
    '--hero-cta-bg': backgroundColor,
    '--hero-cta-color': getHeroCtaTextColor(key),
    ...getHeroCtaHoverColors(key),
  };
}
